<template>
  <div>
    <title-bar :title-stack="titleStack" />
    <hero-bar>
      Report Definition Tabular Form
      <div slot="right">
        <b-button type="is-normal import-button" @click="redirectToReport"
          >Cancel</b-button
        >
        <b-button
          type="is-primary import-button"
          @click="activateWorkflowDialog"
          v-if="!isViewOnly && isEditAllowed"
          >Save</b-button
        >
      </div>
    </hero-bar>
    <section class="section is-main-section">
      <b-collapse class="validation-panel" animation="slide">
        <div class="card validation-card">
          <div class="card-content">
            <div class="columns">
              <div
                class="column columns no-margin"
                v-if="formData && formData.parent_report_definition_id"
              >
                <div class="column">
                  <b-icon icon="file-chart-outline"></b-icon>
                </div>
                <div class="column is-three-quarters">
                  <div
                    class="columns validation-text-header"
                    v-if="formData && formData.parent_report_definition_id"
                  >
                    Follow Up Report Type
                    <span
                      @click.prevent="redirectToKDB(formData.report_url)"
                      v-if="formData && formData.parent_report_definition_id"
                    >
                      <b-icon size="is-small" icon="open-in-new"></b-icon>
                    </span>
                  </div>
                  <div class="columns">
                    <p
                      class="no-padding validation-import-comments"
                      v-if="
                        formData &&
                          formData.parent_report_definition_id &&
                          formData.report_type
                      "
                    >
                      {{ formData.report_type }}
                    </p>
                  </div>
                </div>
              </div>
              <div class="column columns no-margin">
                <div class="column">
                  <b-icon icon="chart-box-outline"></b-icon>
                </div>
                <div class="column is-three-quarters">
                  <div class="columns validation-text-header">
                    {{
                      formData && formData.parent_report_definition_id
                        ? "Parent Report Definition"
                        : "Report Type"
                    }}
                    <span
                      @click.prevent="
                        redirectToReportDefinition(
                          formData.parent_report_definition_id
                        )
                      "
                      v-if="formData && formData.parent_report_definition_id"
                    >
                      <b-icon size="is-small" icon="open-in-new"></b-icon>
                    </span>
                    <span
                      @click.prevent="redirectToKDB(formData.report_url)"
                      v-else
                    >
                      <b-icon size="is-small" icon="open-in-new"></b-icon>
                    </span>
                  </div>
                  <div class="columns">
                    <p
                      class="no-padding validation-import-comments"
                      v-if="formData && formData.report_type"
                    >
                      {{
                        formData && formData.parent_report_definition_id
                          ? formData.parent_report_type
                          : formData.report_type
                      }}
                    </p>
                  </div>
                </div>
              </div>
              <div class="column columns no-margin">
                <div class="column">
                  <b-icon icon="calendar-start"></b-icon>
                </div>
                <div class="column is-three-quarters">
                  <div class="columns validation-text-header">
                    Valid From
                  </div>
                  <div class="columns">
                    <a
                      ref="#"
                      @click.prevent="setDate('Valid From', 'valid_from')"
                    >
                      <p
                        class="no-padding validation-import-comments"
                        v-if="formData && formData.valid_from"
                      >
                        {{ formData.valid_from }}
                      </p>
                      <p class="no-padding validation-import-comments" v-else>
                        Set Start
                      </p></a
                    >
                  </div>
                </div>
              </div>
              <div class="column columns no-margin">
                <div class="column">
                  <b-icon icon="calendar-end"></b-icon>
                </div>
                <div class="column is-three-quarters">
                  <div class="columns validation-text-header">
                    Valid To
                  </div>
                  <div class="columns">
                    <a ref="#" @click.prevent="setDate('Valid To', 'valid_to')"
                      ><p
                        class="no-padding validation-import-comments"
                        v-if="formData && formData.valid_to"
                      >
                        {{ formData.valid_to }}
                      </p>
                      <p class="no-padding validation-import-comments" v-else>
                        Set Finish
                      </p></a
                    >
                  </div>
                </div>
              </div>
              <div class="column columns no-margin" v-if="formData && !isAdd">
                <div class="column">
                  <b-icon icon="calendar-clock"></b-icon>
                </div>
                <div class="column is-three-quarters" v-if="!isAdd">
                  <div class="columns validation-text-header">
                    Last Updated
                  </div>
                  <div class="columns">
                    <p class="no-padding" v-if="formData">
                      {{ formData.updated_at }}
                    </p>
                  </div>
                </div>
              </div>
              <div class="column columns no-margin" v-if="formData && !isAdd">
                <div class="column">
                  <b-icon icon="account-edit"></b-icon>
                </div>
                <div class="column is-three-quarters" v-if="!isAdd">
                  <div class="columns no-padding validation-text-header">
                    Last Updated by
                  </div>
                  <div class="columns">
                    <p class="no-padding">{{ formData.updated_by_name }}</p>
                  </div>
                </div>
              </div>
              <div class="column columns no-margin">
                <div class="column">
                  <b-icon icon="content-save"></b-icon>
                </div>
                <div class="column is-three-quarters">
                  <div class="columns no-padding validation-text-header">
                    Current Status
                  </div>
                  <div class="columns">
                    <p
                      v-if="formData && !isAdd"
                      class="no-padding validation-import-status"
                    >
                      {{ formData.status }}
                      &nbsp;&nbsp;
                      <span
                        v-if="formData.status == 'Rejected'"
                        class="additional-info"
                      >
                        <b-tooltip
                          type="is-primary"
                          :label="formData.comment_for_rejection"
                          multilined
                        >
                          <i class="mdi mdi-information"></i>
                        </b-tooltip>
                      </span>
                    </p>
                    <p v-else class="no-padding validation-import-comments">
                      Unsaved
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </b-collapse>
    </section>
    <section class="section is-main-section no-padding-top" v-if="formData">
      <div class="report-definition-scope">
        <div class="scope-bundle" v-if="formData.country_name">
          <div class="scope">
            <div class="country-with-flag">
              <country-flag
                :country="formData.country_code"
                size="small"
                v-if="formData.country_code"
              />
              <span class="scope-text">{{ formData.country_name }}</span>
            </div>
          </div>
          <hr class="scope-hr" />
        </div>
        <div class="scope-bundle" v-if="formData.scheme_name">
          <div class="scope">
            <span class="scope-text">{{ formData.scheme_name }}</span>
          </div>
          <hr class="scope-hr" />
        </div>
        <div class="scope-bundle" v-if="formData.stream_name">
          <div class="scope">
            <span class="scope-text">{{ formData.stream_name }}</span>
          </div>
          <hr class="scope-hr" />
        </div>
        <ul class="scope-rule-list">
          <li v-for="(value, index) in scopeData" :key="index" class="scope">
            <span v-on:click="showRule(value)"
              ><a href="#">{{ value.name }}</a></span
            >
          </li>
        </ul>
        <hr />
      </div>
      <div class="scope-bundle">
        <div class="tables-header">
          <h3>Sheets</h3>
          <div class="tables-action-buttons" v-if="!isViewOnly">
            <b-button
              type="is-primary"
              icon-left="plus"
              @click="openSheetTableConfigModal"
            >
              Add Sheet
            </b-button>
          </div>
        </div>
        <b-loading :active="tablesLoading" :is-full-page="false"></b-loading>
        <SheetTableConfig
          v-if="isSheetConfigModalActive"
          :is-active="isSheetConfigModalActive"
          :sheet-name="
            editingSheetIndex !== null
              ? formData.sheet_config[editingSheetIndex].name
              : ''
          "
          :existing-tables="
            editingSheetIndex !== null ? getSheetTables(editingSheetIndex) : []
          "
          :existing-sheet-names="getExistingSheetNames()"
          @cancel="cancelSheetConfig"
          @save="onSheetTableConfigSave"
        />

        <!-- Display Sheets as Tabs with Lazy Loading -->
        <div
          v-if="formData.sheet_config && formData.sheet_config.length"
          class="sheets-tabbed-container"
        >
          <b-tabs
            v-model="activeSheetIndex"
            class="sheets-tabs"
            type="is-boxed"
          >
            <b-tab-item
              v-for="(sheet, sheetIdx) in formData.sheet_config"
              :key="'sheet-tab-' + sheetIdx"
              :label="sheet.name"
              lazy
            >
              <!-- Sheet Actions Toolbar -->
              <div class="sheet-actions-toolbar" v-if="!isViewOnly">
                <div class="sheet-action-buttons">
                  <b-button
                    v-if="sheetIdx > 0"
                    type="is-primary"
                    size="is-small"
                    icon-left="arrow-left"
                    @click="moveSheetUp(sheetIdx)"
                    class="button-margin"
                  >
                    Move Left
                  </b-button>
                  <b-button
                    v-if="sheetIdx < formData.sheet_config.length - 1"
                    type="is-primary"
                    size="is-small"
                    icon-left="arrow-right"
                    @click="moveSheetDown(sheetIdx)"
                    class="button-margin"
                  >
                    Move Right
                  </b-button>
                  <b-button
                    type="is-info"
                    size="is-small"
                    icon-left="pencil"
                    @click="editSheet(sheetIdx)"
                    class="button-margin"
                  >
                    Edit {{ sheet.name }}
                  </b-button>
                  <b-button
                    type="is-normal"
                    size="is-small"
                    icon-left="content-copy"
                    @click="copySheet(sheetIdx)"
                    class="button-margin"
                  >
                    Copy {{ sheet.name }}
                  </b-button>
                  <b-button
                    type="is-danger"
                    size="is-small"
                    icon-left="delete"
                    @click="deleteSheet(sheetIdx)"
                    class="button-margin"
                  >
                    Delete {{ sheet.name }}
                  </b-button>
                </div>
              </div>

              <!-- Sheet Tables Content -->
              <div class="sheet-tables">
                <div class="tables-subheader">
                  <h5>Tables</h5>
                  <div class="table-action-buttons" v-if="!isViewOnly">
                    <b-button
                      type="is-primary"
                      size="is-small"
                      icon-left="plus"
                      @click="openTableConfigModal(sheetIdx)"
                    >
                      Add Table
                    </b-button>
                  </div>
                </div>

                <!-- Table Config Modal (for adding/editing individual tables) -->
                <TableConfig
                  v-if="
                    isTableConfigModalActive && currentSheetIndex === sheetIdx
                  "
                  :is-active="
                    isTableConfigModalActive && currentSheetIndex === sheetIdx
                  "
                  :table-name="
                    editingTableIndex !== null && currentSheetIndex === sheetIdx
                      ? sheet.tables[editingTableIndex].table_json.tableName
                      : copiedTableData
                      ? copiedTableData.tableName
                      : ''
                  "
                  :headers="
                    editingTableIndex !== null && currentSheetIndex === sheetIdx
                      ? sheet.tables[editingTableIndex].table_json.headers
                      : copiedTableData
                      ? copiedTableData.headers
                      : []
                  "
                  :existing-table-names="getExistingTableNamesInSheet(sheetIdx)"
                  :editing-index="editingTableIndex"
                  @cancel="cancelTableConfig"
                  @save="onTableConfigSave"
                />

                <!-- Tables in Sheet -->
                <div v-if="sheet.tables && sheet.tables.length">
                  <div
                    v-for="(table, tableIdx) in sheet.tables"
                    :key="'table-' + table.id + '-' + sheetIdx"
                  >
                    <!-- Table Order Controls -->
                    <div
                      v-if="!isViewOnly && sheet.tables.length > 1"
                      style="display: flex; gap: 8px; margin-bottom: 12px; margin-top: 12px; align-items: center;"
                    >
                      <b-button
                        v-if="tableIdx > 0"
                        type="is-primary"
                        size="is-small"
                        icon-left="arrow-up"
                        @click="moveTableUp(sheetIdx, tableIdx)"
                      >
                        Move Up
                      </b-button>
                      <b-button
                        v-if="tableIdx < sheet.tables.length - 1"
                        type="is-primary"
                        size="is-small"
                        icon-left="arrow-down"
                        @click="moveTableDown(sheetIdx, tableIdx)"
                      >
                        Move Down
                      </b-button>
                      <b-tag type="is-light" style="margin-left: auto;">
                        Table {{ tableIdx + 1 }} of {{ sheet.tables.length }}
                      </b-tag>
                    </div>
                    <!-- Show loading skeleton for tables beyond first 2, until rules load -->
                    <div
                      v-if="tableIdx > 1 && !rulesLoaded"
                      class="table-loading-skeleton"
                    >
                      <div class="skeleton-header"></div>
                      <div class="skeleton-body"></div>
                    </div>
                    <CustomTable
                      v-else
                      :key="
                        'table-' +
                          (sheet.id || sheetIdx) +
                          '-' +
                          (table.id || tableIdx)
                      "
                      :ref="'customTable_' + sheetIdx + '_' + tableIdx"
                      :config-index="tableIdx"
                      :table-index="0"
                      :table-title="table.table_json.tableName"
                      :headers="table.table_json.headers"
                      :initial-categories="table.table_json.categories || []"
                      :initial-cell-values="table.table_json.cellValues || {}"
                      :is-view-only="isViewOnly"
                      :form-data="formData"
                      :rules-list="cachedRules"
                      :categories-list="cachedCategories"
                      @view-rule="showRule"
                      @edit-table="editTable($event, sheetIdx)"
                      @copy-table="copyTable($event, sheetIdx)"
                      @delete-table="deleteTable($event, sheetIdx)"
                    />
                  </div>
                </div>
                <div v-else class="no-tables-message">
                  <p>
                    No tables in this sheet yet. Click "Add Table" to create
                    one.
                  </p>
                </div>
              </div>
            </b-tab-item>
          </b-tabs>
        </div>
      </div>
      <br /><br />
      <div
        class="columns"
        v-if="formData && formData.status == 'Sent for Approval' && !isViewOnly"
      >
        <div class="column">
          <ul class="context-options-left">
            <li>
              <b-button
                slot="right"
                native-type="submit"
                type="is-success"
                @click="addOrEditReport('confirm')"
              >
                Approve
              </b-button>
            </li>
            <li>
              <b-button
                slot="right"
                @click="rejectBtnAction"
                type="is-danger"
                class="deactivateBtn"
              >
                Reject
              </b-button>
            </li>
          </ul>
        </div>
      </div>
    </section>
    <SetTimeModal
      :is-active="isModalActive"
      :modalHeader="setModalHeader"
      :formData="formDataDate"
      @confirm="setConfirmTime"
      @cancel="exitModal"
    />
    <view-rules
      :is-active="isViewModalActive"
      :formData="viewRule"
      @cancel="cancelViewRule"
      :show-edit-button="false"
      :rule-tags="ruleTags"
      @checkReportDef="openReportDefList"
    />
    <workflow-dialog
      :is-active="isWorkflowDialogActive"
      @submit="addOrEditReport"
      @cancel="closeWorkflowDialog"
    />

    <report-definition-validity-dialog
      :is-active="isReportDefintionValidityDialogActive"
      :message="validityMessage"
      @submit="forceAddOrRefreshReport"
      @cancel="closeReportDefintionValidityDialog"
    />
    <view-report-def
      :is-active="isViewReportDefModalActive"
      :formData="viewRule"
      @cancel="cancelViewReportDef"
    />

    <show-comments
      :is-active="isShowCommentActive"
      @cancel="closeShowComment"
      :data="formData"
    />
    <b-modal v-model="isRejectModalActive" has-modal-card>
      <div class="modal-card">
        <header class="modal-card-head">
          <p class="modal-card-title title-reject">
            You are rejecting the changes
          </p>
        </header>
        <section class="modal-card-body">
          <b-field label="Please describe the reasons">
            <b-input
              maxlength="500"
              type="textarea"
              v-model="comment"
            ></b-input>
          </b-field>
        </section>
        <footer class="modal-card-foot">
          <b-button
            label="Close"
            class="reject-modal-close-button"
            @click="isRejectModalActive = false"
          />
          <b-button label="Reject" type="is-danger" @click="rejectScope" />
        </footer>
      </div>
    </b-modal>
    <b-loading
      :is-full-page="true"
      v-model="isLoading"
      :can-cancel="false"
    ></b-loading>
  </div>
</template>

<script>
import TitleBar from "@/components/TitleBar";
import HeroBar from "@/components/HeroBar";
import RulesManagerService from "../../services/RulesManagerService";
import { mapGetters } from "vuex";
import SetTimeModal from "@/components/RulesManager/SetTimeModal.vue";
import UtilityMixin from "@/mixins/UtilityMixin";
import ViewRules from "@/components/RulesManager/ViewRules.vue";
import WorkflowDialog from "@/components/RulesManager/WorkflowDialog.vue";
import ShowComments from "@/components/RulesManager/ShowComments.vue";
import SheetTableConfig from "@/components/RulesManager/SheetTableConfig.vue";
import TableConfig from "@/components/RulesManager/TableConfig.vue";
import CustomTable from "@/components/RulesManager/CustomTable.vue";
import ReportDefinitionValidityDialog from "@/components/RulesManager/ReportDefinitionValidityDialog.vue";
import ViewReportDef from "@/components/RulesManager/ViewReportDef.vue";
import { UserGroup } from "@/services/UserGroups";
import * as dayjs from "dayjs";
export default {
  name: "ReportDefinition",
  components: {
    HeroBar,
    TitleBar,
    SetTimeModal,
    ViewRules,
    WorkflowDialog,
    ShowComments,
    ReportDefinitionValidityDialog,
    ViewReportDef,
    SheetTableConfig,
    TableConfig,
    CustomTable
  },
  mixins: [UtilityMixin],
  props: {
    isViewOnly: {
      type: Boolean,
      default: false
    },
    isDefinitionView: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      activeSheetIndex: 0,
      isSheetConfigModalActive: false,
      editingSheetIndex: null,
      currentSheetIndex: null,
      isTableConfigModalActive: false,
      editingTableIndex: null,
      copiedTableData: null,
      hover: false,
      viewRule: {},
      data: [],
      formData: null,
      isDataLoading: false,
      isLoading: false,
      isModalActive: false,
      isViewModalActive: false,
      action: null,
      isAdd: this.$route.params.isAdd,
      scopeData: this.$route.params.scopeData,
      editObject: this.getClearFormObject(),
      viewOnly: false,
      RulesManagerService: new RulesManagerService(),
      valid_to: null,
      valid_from: null,
      setModalKey: null,
      setModalHeader: null,
      formDataDate: null,
      isWorkflowDialogActive: false,
      isShowCommentActive: false,
      isRejectModalActive: false,
      isReportDefintionValidityDialogActive: false,
      isViewReportDefModalActive: false,
      validityMessage: null,
      workflow: null,
      comment: null,
      ruleTags: [],
      cachedRules: [],
      cachedCategories: [],
      rulesLoaded: false,
      categoriesLoaded: false,
      lastWatchedFormData: null // Track last watched formData to prevent duplicate API calls
    };
  },
  computed: {
    ...mapGetters(["userId", "userName", "userHasPermission", "userGroups"]),
    editObjectName() {
      return this.editObject || this.getClearFormObject();
    },
    tablesLoading() {
      // Only show loader during initial data fetch, not while rules/categories load
      return this.isLoading;
    },
    titleStack() {
      return [
        { url: "#", name: "Rules Manager" },
        { url: "/rulesManager/reportDefinitions", name: "Report Definitions" },
        { url: "#", name: "Report Definition" }
      ];
    },
    isEditAllowed() {
      if (this.userGroups.includes(UserGroup.EPR_ADMIN)) {
        return true;
      } else {
        return false;
      }
    }
  },
  mounted() {
    // Distinguish between view and definitionView modes based on URL pattern
    this.checkExternalPermission();
    this.fetchRuleTags();
    // Reset cache flags to ensure fresh fetch when component mounts
    this.rulesLoaded = false;
    this.categoriesLoaded = false;
    this.lastWatchedFormData = null;
    this.getReportDefinitionById();
    // Rules and categories will be fetched by the formData watcher once data is loaded
  },

  watch: {
    formData: {
      handler(newVal) {
        // Fetch when formData is first loaded or when critical fields change
        if (newVal) {
          // Check if this is a new formData assignment (lastWatchedFormData is null)
          // OR if critical fields have changed
          const isFirstLoad = !this.lastWatchedFormData;
          const hasChangedFields =
            newVal.stream !== this.lastWatchedFormData?.stream ||
            newVal.country !== this.lastWatchedFormData?.country ||
            newVal.scheme !== this.lastWatchedFormData?.scheme;

          if (isFirstLoad || hasChangedFields) {
            this.lastWatchedFormData = {
              stream: newVal.stream,
              country: newVal.country,
              scheme: newVal.scheme
            };

            // Fetch rules asynchronously on first load or when fields change
            if (!this.rulesLoaded) {
              // Defer to not block UI rendering
              this.$nextTick(() => {
                this.fetchAndCacheRules();
              });
            }
            // Don't fetch categories upfront - let tables fetch on demand
            // if (newVal.country && newVal.stream && newVal.scheme) {
            //   if (!this.categoriesLoaded) {
            //     this.fetchAndCacheCategories();
            //   }
            // }
          }
        }
      },
      deep: false // Don't watch all nested properties, just the object reference change
    }
  },

  methods: {
    // SHEET MANAGEMENT
    getExistingSheetNames() {
      return (this.formData.sheet_config || []).map(sheet => sheet.name);
    },
    getSheetTables(sheetIdx) {
      const sheet = this.formData?.sheet_config?.[sheetIdx];
      if (!sheet) return [];
      const tables =
        (sheet.tables && sheet.tables.length && sheet.tables) ||
        (sheet.table_config &&
          sheet.table_config.length &&
          sheet.table_config) ||
        [];

      // Return a fresh clone so the modal watcher always sees updates
      return JSON.parse(JSON.stringify(tables));
    },
    onSheetTableConfigSave(config) {
      if (!this.formData.sheet_config) {
        this.$set(this.formData, "sheet_config", []);
      }

      if (this.editingSheetIndex !== null) {
        // Update existing sheet with new tables
        const sheet = this.formData.sheet_config[this.editingSheetIndex];
        this.$set(sheet, "name", config.sheetName);
        const existingTables = sheet.tables || [];
        const updatedTables = (config.tables || []).map((tableConfig, idx) => {
          const existing = existingTables[idx];
          const existingJson = existing?.table_json || {};

          return {
            id: existing?.id || idx + 1,
            order: idx + 1,
            table_name: tableConfig.tableName,
            table_json: {
              tableName: tableConfig.tableName,
              headers: tableConfig.headers,
              categories:
                existingJson.categories ||
                (this.cachedCategories && this.cachedCategories.length > 0
                  ? JSON.parse(JSON.stringify(this.cachedCategories))
                  : []),
              cellValues: existingJson.cellValues || {}
            }
          };
        });

        this.$set(sheet, "tables", updatedTables);

        this.$buefy.toast.open({
          message: "Sheet updated with new tables!",
          type: "is-success"
        });
      } else {
        // Add new sheet with tables
        const newSheetId =
          this.formData.sheet_config.length > 0
            ? Math.max(...this.formData.sheet_config.map(s => s.id || 0)) + 1
            : 1;

        const tables = (config.tables || []).map((tableConfig, idx) => {
          const newTableJson = {
            tableName: tableConfig.tableName,
            headers: tableConfig.headers,
            categories: [],
            cellValues: {}
          };

          return {
            id: idx + 1,
            order: idx + 1,
            table_name: tableConfig.tableName,
            table_json: newTableJson
          };
        });

        this.formData.sheet_config.push({
          id: newSheetId,
          name: config.sheetName,
          order: this.formData.sheet_config.length + 1,
          tables: tables
        });

        this.$buefy.toast.open({
          message: "Sheet with tables created successfully!",
          type: "is-success"
        });

        // Navigate to the newly created sheet
        this.activeSheetIndex = this.formData.sheet_config.length - 1;
      }
      this.isSheetConfigModalActive = false;
      this.editingSheetIndex = null;
      this.copiedTableData = null;
    },
    openSheetTableConfigModal() {
      this.editingSheetIndex = null;
      this.isSheetConfigModalActive = true;
    },
    cancelSheetConfig() {
      this.isSheetConfigModalActive = false;
      this.editingSheetIndex = null;
    },
    editSheet(sheetIdx) {
      this.editingSheetIndex = sheetIdx;
      this.isSheetConfigModalActive = true;
    },
    copySheet(sheetIdx) {
      const sheetToCopy = JSON.parse(
        JSON.stringify(this.formData.sheet_config[sheetIdx])
      );
      const newSheetId =
        Math.max(...this.formData.sheet_config.map(s => s.id || 0)) + 1;

      sheetToCopy.id = newSheetId;
      sheetToCopy.name = sheetToCopy.name + " (Copy)";
      sheetToCopy.order = this.formData.sheet_config.length + 1;

      this.formData.sheet_config.push(sheetToCopy);
      this.activeSheetIndex = this.formData.sheet_config.length - 1; // Switch to the copied sheet

      this.$buefy.toast.open({
        message: "Sheet copied successfully!",
        type: "is-success"
      });
    },
    deleteSheet(sheetIdx) {
      this.$buefy.dialog.confirm({
        title: "Delete Sheet",
        message: `Are you sure you want to delete this sheet and all its ${this
          .formData.sheet_config[sheetIdx].tables?.length || 0} tables?`,
        confirmText: "Delete",
        type: "is-danger",
        hasIcon: true,
        onConfirm: () => {
          this.formData.sheet_config.splice(sheetIdx, 1);

          // Keep the active tab in range after deletion
          if (this.activeSheetIndex >= this.formData.sheet_config.length) {
            this.activeSheetIndex = Math.max(
              0,
              this.formData.sheet_config.length - 1
            );
          } else if (this.activeSheetIndex > sheetIdx) {
            this.activeSheetIndex -= 1;
          }

          this.updateSheetOrders();

          this.$buefy.toast.open({
            message: "Sheet deleted successfully!",
            type: "is-success"
          });
        }
      });
    },

    moveSheetUp(sheetIdx) {
      if (sheetIdx <= 0) return;

      // Sync current table states before moving
      this.syncAllTableStates();

      const currentSheet = this.formData.sheet_config[sheetIdx];
      const prevSheet = this.formData.sheet_config[sheetIdx - 1];

      // Swap orders
      const tempOrder = currentSheet.order;
      currentSheet.order = prevSheet.order;
      prevSheet.order = tempOrder;

      // Sort the array by order
      this.sortSheets();

      this.$nextTick(() => {
        this.activeSheetIndex = sheetIdx - 1;
      });
      console.log("Moved sheet up", currentSheet, prevSheet);
      this.$buefy.toast.open({ message: "Sheet moved left", type: "is-info" });
    },
    moveSheetDown(sheetIdx) {
      if (sheetIdx >= this.formData.sheet_config.length - 1) return;

      // Sync current table states before moving
      this.syncAllTableStates();

      const currentSheet = this.formData.sheet_config[sheetIdx];
      const nextSheet = this.formData.sheet_config[sheetIdx + 1];

      // Swap orders
      const tempOrder = currentSheet.order;
      currentSheet.order = nextSheet.order;
      nextSheet.order = tempOrder;

      // Sort the array by order
      this.sortSheets();

      this.$nextTick(() => {
        this.activeSheetIndex = sheetIdx + 1;
      });
      console.log("Moved sheet down", currentSheet, nextSheet);
      this.$buefy.toast.open({ message: "Sheet moved right", type: "is-info" });
    },
    updateSheetOrders() {
      if (this.formData && this.formData.sheet_config) {
        this.formData.sheet_config.forEach((sheet, idx) => {
          this.$set(sheet, "order", idx + 1);
        });
      }
    },
    sortSheets() {
      if (this.formData && this.formData.sheet_config) {
        this.formData.sheet_config.sort((a, b) => a.order - b.order);
      }
    },

    // TABLE MANAGEMENT
    getExistingTableNamesInSheet(sheetIdx) {
      const sheet = this.formData.sheet_config[sheetIdx];
      return (sheet.tables || []).map(
        table => table.table_json?.tableName || ""
      );
    },
    openTableConfigModal(sheetIdx) {
      this.currentSheetIndex = sheetIdx;
      this.editingTableIndex = null;
      this.isTableConfigModalActive = true;
    },
    onTableConfigSave(config) {
      const sheet = this.formData.sheet_config[this.currentSheetIndex];

      if (!sheet.tables) {
        this.$set(sheet, "tables", []);
      }

      if (this.editingTableIndex !== null) {
        // Update existing table
        const table = sheet.tables[this.editingTableIndex];
        const existingTableJson = table.table_json;

        const updatedTableJson = {
          tableName: config.tableName,
          headers: config.headers,
          categories: existingTableJson.categories || [],
          cellValues: existingTableJson.cellValues || {}
        };

        this.$set(table, "table_json", updatedTableJson);

        this.$buefy.toast.open({
          message: "Table updated successfully!",
          type: "is-success"
        });
      } else {
        // Add new table
        const newTableJson = {
          tableName: config.tableName,
          headers: config.headers,
          categories:
            this.copiedTableData?.categories ||
            (this.cachedCategories && this.cachedCategories.length > 0
              ? JSON.parse(JSON.stringify(this.cachedCategories))
              : []),
          cellValues: this.copiedTableData?.cellValues || {}
        };

        const newTableId =
          sheet.tables.length > 0
            ? Math.max(...sheet.tables.map(t => t.id || 0)) + 1
            : 1;

        sheet.tables.push({
          id: newTableId,
          order: sheet.tables.length + 1,
          table_name: config.tableName,
          table_json: newTableJson
        });

        this.$buefy.toast.open({
          message: "Table created successfully!",
          type: "is-success"
        });
      }
      this.isTableConfigModalActive = false;
      this.editingTableIndex = null;
      this.copiedTableData = null;
    },
    cancelTableConfig() {
      this.isTableConfigModalActive = false;
      this.editingTableIndex = null;
    },
    editTable(tableData, sheetIdx) {
      this.currentSheetIndex = sheetIdx;
      this.editingTableIndex = tableData.configIndex;
      this.isTableConfigModalActive = true;
    },
    copyTable(tableData, sheetIdx) {
      this.currentSheetIndex = sheetIdx;
      this.copiedTableData = tableData;
      this.editingTableIndex = null;
      this.isTableConfigModalActive = true;
    },
    deleteTable(tableData, sheetIdx) {
      const sheet = this.formData.sheet_config[sheetIdx];
      sheet.tables.splice(tableData.configIndex, 1);
      this.$buefy.toast.open({
        message: "Table deleted successfully!",
        type: "is-success"
      });
    },
    moveTableUp(sheetIdx, tableIdx) {
      const sheet = this.formData.sheet_config[sheetIdx];
      const tables = sheet.tables;
      const itemToMove = tables[tableIdx];
      this.$set(tables, tableIdx, tables[tableIdx - 1]);
      this.$set(tables, tableIdx - 1, itemToMove);

      this.updateTableOrders(sheetIdx);

      this.$forceUpdate();
      this.$buefy.toast.open({
        message: `Table moved up`,
        type: "is-info"
      });
    },
    moveTableDown(sheetIdx, tableIdx) {
      const sheet = this.formData.sheet_config[sheetIdx];
      const tables = sheet.tables;
      const itemToMove = tables[tableIdx];
      this.$set(tables, tableIdx, tables[tableIdx + 1]);
      this.$set(tables, tableIdx + 1, itemToMove);

      this.updateTableOrders(sheetIdx);

      this.$forceUpdate();
      this.$buefy.toast.open({
        message: `Table moved down`,
        type: "is-info"
      });
    },
    updateTableOrders(sheetIdx) {
      const sheet = this.formData.sheet_config[sheetIdx];
      if (sheet.tables) {
        sheet.tables.forEach((table, idx) => {
          this.$set(table, "order", idx + 1);
        });
      }
    },

    redirectToKDB(url) {
      window.open(url, "_blank");
    },
    redirectToReportDefinition(id) {
      if (!id) return;

      // Get the base URL from the current location
      const baseUrl = window.location.origin;

      // Construct the complete URL manually to ensure it's correct
      const url = `${baseUrl}/rulesManager/reportDefinition/${id}/view`;

      // Open in a new tab with the complete URL
      window.open(url, "_blank");
    },
    fetchRuleTags() {
      this.RulesManagerService.getRulesTags().subscribe(response => {
        this.ruleTags = response;
      });
    },
    fetchAndCacheRules() {
      if (this.rulesLoaded) {
        return; // Already loaded
      }
      const stream =
        this.formData && this.formData.stream ? this.formData.stream : null;
      this.RulesManagerService.getAllRules(stream).subscribe(
        rules => {
          this.cachedRules = rules;
          this.rulesLoaded = true;
        },
        error => {
          console.error("Error fetching rules:", error);
          this.cachedRules = [];
          this.rulesLoaded = true;
        }
      );
    },
    fetchAndCacheCategories() {
      if (this.categoriesLoaded) {
        return; // Already loaded
      }
      // Fetch categories from API if formData is available
      if (
        this.formData &&
        this.formData.country &&
        this.formData.stream &&
        this.formData.scheme
      ) {
        this.RulesManagerService.getReportCategories(this.formData).subscribe(
          response => {
            if (response && response.categories_fees) {
              this.cachedCategories = response.categories_fees.map(cat => ({
                ...cat,
                rules: []
              }));
              this.categoriesLoaded = true;
            }
          },
          error => {
            console.error("Error fetching categories:", error);
          }
        );
      }
    },
    closeShowComment() {
      this.isShowCommentActive = false;
    },
    showComment() {
      this.isShowCommentActive = true;
    },
    rejectBtnAction() {
      this.isRejectModalActive = true;
    },
    rejectScope() {
      this.formData[`comment`] = this.comment;
      this.isRejectModalActive = false;
      this.addOrEditReport("reject");
    },
    activateWorkflowDialog() {
      this.isWorkflowDialogActive = true;
    },
    activateReportDefintionValidityDialog() {
      this.isReportDefintionValidityDialogActive = true;
    },
    closeReportDefintionValidityDialog() {
      this.formData.force_update = false;
      this.isReportDefintionValidityDialogActive = false;
    },
    closeWorkflowDialog() {
      this.isWorkflowDialogActive = false;
    },
    forceAddOrRefreshReport(value) {
      if (value == "refresh") {
        this.refreshNewCategories();
      } else if (value == "reload") {
        this.formData.force_update = true;
        this.addReport(this.workflow);
      }
      return true;
    },
    showRule(value) {
      const tagSelected = this.ruleTags
        .filter(item => (value["tags"] ? value["tags"].includes(item.id) : ""))
        .map(a => a.name)
        .toString();

      value["tags"] = tagSelected == "" ? "NA" : tagSelected;
      this.isViewModalActive = true;
      this.viewRule = value;
    },
    cancelViewRule() {
      this.isViewModalActive = false;
    },
    openReportDefList() {
      this.isViewReportDefModalActive = true;
    },
    cancelViewReportDef() {
      this.isViewReportDefModalActive = false;
    },

    setConfirmTime(value) {
      this.formData[`${this.setModalKey}`] = new Date(value).toLocaleDateString(
        "fr-CA"
      );

      this.isModalActive = false;
    },
    convertToDate(dt) {
      let newDate = null;
      if (dt == " - ") {
        return newDate;
      }
      if (dt != null) {
        newDate = new Date(dt);
      }
      return newDate;
    },
    getReportDefinitionById() {
      if (this.$route.params.id) {
        this.isLoading = true;
        this.RulesManagerService.getReportDefinitionById(
          this.$route.params.id,
          this.isViewOnly,
          this.isDefinitionView
        ).subscribe(response => {
          this.formData = response;

          // Handle sheet_config - either new structure or migrate from old table_config
          if (this.formData.sheet_config && this.formData.sheet_config.length) {
            // sheet_config structure is already flattened - no extraction needed
            this.formData.sheet_config = this.formData.sheet_config.map(
              sheet => {
                if (sheet.sheet_json) {
                  return JSON.parse(JSON.stringify(sheet.sheet_json));
                }
                return sheet;
              }
            );
          } else if (
            this.formData.table_config &&
            this.formData.table_config.length
          ) {
            // Migrate old table_config structure to new sheets structure
            const tables = this.formData.table_config.map(config => {
              // Normalize nested table_json if present
              const tableJson =
                config.table_json && config.table_json.table_json
                  ? config.table_json.table_json
                  : config.table_json;

              return {
                id: config.id,
                order: config.order || 1,
                table_json: tableJson
              };
            });

            // Sort tables by order
            tables.sort((a, b) => {
              if (a.order !== undefined && b.order !== undefined) {
                return a.order - b.order;
              }
              return (a.id || 0) - (b.id || 0);
            });

            // Wrap in first sheet
            this.formData.sheet_config = [
              {
                id: 1,
                name: "Sheet 1",
                order: 1,
                tables: tables
              }
            ];
          } else {
            // New report - initialize with empty sheets array
            this.formData.sheet_config = [];
          }

          this.updateSheetOrders();
          this.fetchScopes(response);

          this.formData.updated_at
            ? (this.formData.updated_at = dayjs(
                this.formData.updated_at
              ).format("YYYY-MM-DD, HH:mm"))
            : null;

          // Reset cache flags to trigger watcher to fetch rules/categories
          // (Watcher will handle the API calls to avoid duplicates)
          this.rulesLoaded = false;
          this.categoriesLoaded = false;
          this.lastWatchedFormData = null;

          this.isLoading = false;
        }, this.handleEditApiError);
      } else if (this.$route.params.formData) {
        this.formData = this.$route.params.formData;

        // Handle sheet_config - either new structure or migrate from old table_config
        if (this.formData.sheet_config && this.formData.sheet_config.length) {
          // sheet_config structure is already flattened - no extraction needed
          this.formData.sheet_config = this.formData.sheet_config.map(sheet => {
            if (sheet.sheet_json) {
              return JSON.parse(JSON.stringify(sheet.sheet_json));
            }
            return sheet;
          });
        } else if (
          this.formData.table_config &&
          this.formData.table_config.length
        ) {
          // Migrate old table_config structure to new sheets structure
          const tables = this.formData.table_config.map(config => {
            // Normalize nested table_json if present
            const tableJson =
              config.table_json && config.table_json.table_json
                ? config.table_json.table_json
                : config.table_json;

            return {
              id: config.id,
              order: config.order || 1,
              table_json: tableJson
            };
          });

          // Sort tables by order
          tables.sort((a, b) => {
            if (a.order !== undefined && b.order !== undefined) {
              return a.order - b.order;
            }
            return (a.id || 0) - (b.id || 0);
          });

          // Wrap in first sheet
          this.formData.sheet_config = [
            {
              id: 1,
              name: "Sheet 1",
              order: 1,
              tables: tables
            }
          ];
        } else {
          // New report - initialize with empty sheets array
          this.formData.sheet_config = [];
        }

        this.updateSheetOrders();

        // Reset cache flags to trigger watcher to fetch rules/categories
        // (Watcher will handle the API calls to avoid duplicates)
        this.rulesLoaded = false;
        this.categoriesLoaded = false;
        this.lastWatchedFormData = null;
      } else {
        this.$buefy.dialog.alert({
          title: "Error",
          message: "There is an issue while fetching data. Please try again.",
          type: "is-danger",
          ariaRole: "alertdialog",
          ariaModal: true
        });
        this.redirectToReport();
      }
    },
    getClearFormObject() {
      this.formData = [];
    },
    redirectToReport() {
      this.formData = [];

      // First try to navigate using Vue Router
      try {
        this.$router.push({
          name: "rulesManager.reportDefinitions"
        });
      } catch (error) {
        // If Vue Router navigation fails, use a direct URL approach
        const baseUrl = window.location.origin;
        window.location.href = `${baseUrl}/rulesManager/reportDefinitions`;
      }
    },

    addOrEditReport(workflow) {
      this.workflow = workflow;
      this.closeWorkflowDialog();
      // Set is_tabular flag as always true for all tabular report operations
      this.formData.is_tabular = true;
      // Sync all table states before proceeding
      this.syncAllTableStates();
      if (this.formData.valid_to && this.formData.valid_from) {
        if (this.$route.params.id) {
          this.editReport(workflow);
        } else {
          this.addReport(workflow);
        }
      } else {
        this.$buefy.dialog.alert({
          title: "Error",
          message: "Please select a date for 'Valid from' / 'Valid to'",
          type: "is-danger",
          ariaRole: "alertdialog",
          ariaModal: true
        });
      }
    },

    refreshNewCategories() {
      this.RulesManagerService.getReportCategories(this.formData).subscribe(
        () => {
          // Categories are now managed within table_json for tabular reports
          this.formData.valid_from_old = this.formData.valid_from;
          this.formData.valid_to_old = this.formData.valid_to;
          this.closeReportDefintionValidityDialog();
        },
        () => {
          alert(
            "Could not fetch the valid reporting categories with the selected date range!"
          );
        }
      );
    },
    syncAllTableStates() {
      // Sync categories and cellValues from all CustomTable components before saving
      if (!this.formData.sheet_config) return;

      this.formData.sheet_config.forEach((sheet, sheetIdx) => {
        if (!sheet.tables) return;

        sheet.tables.forEach((table, tableIdx) => {
          if (!table.table_json) return;

          // Reference key follows pattern: customTable_{sheetIdx}_{tableIdx}
          const refKey = `customTable_${sheetIdx}_${tableIdx}`;
          const tableRef = this.$refs[refKey];
          if (tableRef && tableRef[0]) {
            const tableComponent = tableRef[0];
            // Preserve existing categories if component doesn't have them
            if (
              tableComponent.localCategories &&
              tableComponent.localCategories.length > 0
            ) {
              table.table_json.categories = tableComponent.localCategories;
            } else if (
              !table.table_json.categories ||
              table.table_json.categories.length === 0
            ) {
              // Only set to empty if categories were not already present
              table.table_json.categories =
                tableComponent.localCategories || [];
            }
            table.table_json.cellValues = tableComponent.cellValues || {};
          }
        });
      });

      // Ensure order fields are up to date before saving
      this.formData.sheet_config.forEach((sheet, sheetIdx) => {
        this.updateTableOrders(sheetIdx);
      });
    },
    addReport(workflow) {
      // Sync all table states before saving
      this.syncAllTableStates();
      this.isLoading = true;
      // Set is_tabular flag as always true for tabular reports
      this.formData.is_tabular = true;
      this.RulesManagerService.addTabularReportDefinition(
        this.formData,
        workflow
      ).subscribe(response => {
        const categories = response.categories_fees;
        if (
          (categories && categories.length) ||
          response.cat_removed ||
          response.cat_added
        ) {
          if (categories.length) {
            let messageBody = "";
            if (response.cat_removed) {
              messageBody =
                "<strong>Following  categories do not  match the validity of the report definition.</strong>";
              messageBody +=
                "<strong>Click cancel to change the validity, continue to save the report defintion  otherwise refresh to remove the categories.</strong><br>";
            } else if (categories.cat_added) {
              messageBody =
                "<strong>Following categories do not  match the validity of the report definition.</strong>";
              messageBody +=
                "<strong>Click cancel to change the validity, continue to save the report defintion otherwise refresh to load the changed categories.</strong><br>";
            }
            messageBody += "<ul>";

            categories.forEach(function(item, index) {
              messageBody += "<li>";
              messageBody += index + 1 + ". " + item.category;
              if (item.sub_category != "N/A") {
                messageBody += ": " + item.sub_category;
              }
              messageBody +=
                " " + item.valid_from + " to " + item.valid_to + "</li>";
            });
            messageBody + "</ul>";
            this.validityMessage = messageBody;
            this.activateReportDefintionValidityDialog();

            /*  this.$buefy.dialog.confirm({
              title: "Warning!",
              message: messageBody,
              type: "is-danger",
              confirmText: "Refresh",
              onConfirm: () => this.refreshNewCategories()
            }); */
          } else {
            const messageBody =
              "No matching reporting categories exist. Please adjust the report validity.";
            this.isLoading = false;
            this.$buefy.dialog.alert({
              title: "Error",
              message: messageBody,
              type: "is-danger"
            });
          }
        } else {
          this.$buefy.toast.open({
            message: "Data is added successfully!",
            type: "is-success"
          });
          // Keep loading until redirect completes
          this.redirectToReport();
        }
      }, this.handleApiError);
    },

    continueEditingReport(workflow) {
      // Set is_tabular flag as always true for tabular reports
      this.formData.is_tabular = true;
      this.RulesManagerService.editTabularReportDefinition(
        this.formData,
        workflow,
        true
      ).subscribe(() => {
        this.$buefy.toast.open({
          message: "Data is updated successfully!",
          type: "is-success"
        });
        this.redirectToReport();
      }, this.handleApiError);
    },
    editReport(workflow) {
      // Sync all table states before saving
      this.syncAllTableStates();
      this.isLoading = true;
      // Set is_tabular flag as always true for tabular reports
      this.formData.is_tabular = true;
      this.RulesManagerService.editTabularReportDefinition(
        this.formData,
        workflow
      ).subscribe(response => {
        // show pop up for invalid categories and fees
        const invalidCategories = response.categories_fees;

        if (invalidCategories) {
          let messageBody =
            "<strong>Following categories do not match the validity of the report definition.</strong>";
          messageBody +=
            "<strong>Click cancel to change the validity otherwise continue, if you continue those categories will be removed from the report definition too.</strong><br>";
          invalidCategories.forEach(function(item) {
            messageBody += item.category;
            if (item.sub_category != "N/A") {
              messageBody += ": " + item.sub_category;
            }
            messageBody +=
              " " + item.valid_from + " to " + item.valid_to + "<br>";
          });

          if (
            response.invalid_report_definition == "True" &&
            response.stop_continue == "False"
          ) {
            this.$buefy.dialog.confirm({
              title: "Warning!",
              message: messageBody,
              type: "is-danger",
              confirmText: "Continue",
              onConfirm: () => this.continueEditingReport(workflow)
            });
          } else if (
            response.invalid_report_definition == "True" &&
            response.stop_continue == "True"
          ) {
            this.isLoading = false;
            this.$buefy.dialog.alert({
              title: "Error",
              message: messageBody,
              type: "is-danger"
            });
          } else {
            this.continueEditingReport(workflow);
          }
        } else {
          this.$buefy.toast.open({
            message: "Data is updated successfully!",
            type: "is-success"
          });
          // Keep loading until redirect completes
          this.redirectToReport();
        }
      }, this.handleApiError);
    },
    exitModal() {
      this.setModalHeader = null;
      this.setModalKey = null;
      this.isModalActive = false;
    },

    setDate(value, key) {
      if (!this.isViewOnly && this.isEditAllowed) {
        this.setModalHeader = value;
        this.setModalKey = key;
        this.isModalActive = true;
        this.formDataDate = this.convertToDate(
          this.formData[`${this.setModalKey}`]
        );
      }
    },
    handleEditApiError(reason) {
      this.isLoading = false;
      let errorMessage = reason.response.data["detail"];

      if (errorMessage == null || errorMessage == undefined) {
        errorMessage = "Invalid input";
      }
      this.$buefy.dialog.alert({
        title: "Error",
        message: errorMessage,
        type: "is-danger",
        ariaRole: "alertdialog",
        ariaModal: true,
        onConfirm: () => this.redirectToReport()
      });
    },
    handleApiError(reason) {
      this.isLoading = false;
      let errorMessage = null;
      if (reason?.response?.data) {
        if (reason.response.data["detail"]) {
          errorMessage = reason.response.data["detail"];
        } else if (reason.response.data["error"]) {
          errorMessage = reason.response.data["error"];
        } else if (reason.response.data["name"]) {
          errorMessage = reason.response.data["name"];
        } else {
          errorMessage = "Invalid input";
        }
      }
      this.$buefy.dialog.alert({
        title: "Error",
        message: errorMessage,
        type: "is-danger",
        ariaRole: "alertdialog",
        ariaModal: true
        //onConfirm: () => this.redirectToReport()
      });
    },

    fetchScopes(formData) {
      this.RulesManagerService.getFilterScopeData(formData).subscribe(
        response => {
          this.scopeData = response.results;
        }
      );
    }
  }
};
</script>

<style scoped>
* {
  user-select: text;
  -webkit-user-select: text;
  -moz-user-select: text;
  -ms-user-select: text;
}

:deep(.b-tabs .tab-content) {
  padding: 0 !important;
}

.tab-content {
  padding: 0px !important;
}
.tables-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 24px;
  padding-bottom: 16px;
  border-bottom: 2px solid #e0e0e0;
}

.tables-header h3 {
  margin: 0;
  font-size: 1.5rem;
  font-weight: 600;
  color: #363636;
}

.tables-action-buttons {
  display: flex;
  gap: 12px;
}

/* Sheets Tabs Styling */
.sheets-tabbed-container {
  margin-top: 20px;
}

.sheets-tabs {
  margin-bottom: 0;
}

.sheets-tabs.is-boxed .tabs {
  border-bottom: 2px solid #dbdbdb;
  background-color: #fafafa;
  border-radius: 4px 4px 0 0;
}

.sheets-tabs.is-boxed .tabs li.is-active a {
  background-color: #fff;
  border-color: #3273dc;
  color: #3273dc;
}

.button.is-normal {
  font-size: 0.8rem !important;
}

/* Sheet Actions Toolbar */
.sheet-actions-toolbar {
  background-color: #f5f5f5;
  padding: 16px;
  border-bottom: 1px solid #e0e0e0;
  border-radius: 0 0 4px 4px;
  margin-bottom: 24px;
}

.sheet-action-buttons {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
  align-items: center;
}

.button-margin {
  margin: 0;
}

.sheet-tables {
  padding: 0;
}

.tables-subheader {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
  margin-top: 16px;
}

.tables-subheader h5 {
  margin: 0;
  font-size: 1.1rem;
  font-weight: 600;
  color: #363636;
}

.table-action-buttons {
  display: flex;
  gap: 8px;
}

.no-tables-message {
  text-align: center;
  padding: 40px 20px;
  color: #7a7a7a;
  background-color: #fafafa;
  border-radius: 4px;
  border: 1px dashed #e0e0e0;
}

.table-loading-skeleton {
  margin-bottom: 32px;
  animation: pulse 1.5s ease-in-out infinite;
}

.skeleton-header {
  height: 48px;
  background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
  background-size: 200% 100%;
  animation: shimmer 1.5s infinite;
  border-radius: 4px;
  margin-bottom: 8px;
}

.skeleton-body {
  height: 200px;
  background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
  background-size: 200% 100%;
  animation: shimmer 1.5s infinite;
  border-radius: 4px;
}

@keyframes shimmer {
  0% {
    background-position: -200% 0;
  }
  100% {
    background-position: 200% 0;
  }
}

@keyframes pulse {
  0%,
  100% {
    opacity: 1;
  }
  50% {
    opacity: 0.8;
  }
}
</style>
